var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSkipPrev = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#skip_prev_svg__clip0_1442_3608)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 6h2v12H6V6Zm3.5 6 8.5 6V6l-8.5 6Zm6.5 2.14L12.97 12 16 9.86v4.28Z"
}))));
export default SvgSkipPrev;